<now-header wide="true"></now-header>
<now-fallback-header wide="true" [attr.base-path]="nowPortalBasePath" />
